// Slide Functions

export function slides() {
   const testimonalSection = document.querySelector('.testimonial-section')
   const slides = document.querySelectorAll('.slide');
   const slideWrapper = document.querySelector('.testimonial-section__container--testimonials')
   let tallestElement = 0;
   const btnLeft = document.querySelector('.slider__btn--left');
   const btnRight = document.querySelector('.slider__btn--right');
   let currentSlide = 0;
   const maxSlide = slides.length;
   const dotContainer = document.querySelector('.dots');
   

   const createDots = function ()
   {
      slides.forEach(function (_, i) {
         dotContainer.insertAdjacentHTML('beforeend', `<button class="dots__dot" data-slide="${i}"></button>`)
      });
   }
   createDots();

   const activateDot = function (slide) {
      document.querySelectorAll('.dots__dot').forEach(dot => dot.classList.remove('dots__dot--active'));

      document.querySelector(`.dots__dot[data-slide="${slide}"]`).classList.add('dots__dot--active');
   }


   // 
   const goToSlide = function (slide) {
      slides.forEach((s, i) => {
         s.style.transform =
            `translateX(${100 * (i - slide) }%)`
      });
      activateDot(slide);
   }

   goToSlide(0);
   
   

   // next slide
   const nextSlide = function () {
      if (currentSlide === maxSlide - 1) {
         currentSlide = 0;
      } else {
         currentSlide++;
      }
      goToSlide(currentSlide);
   }

   const prevSlide = function () {
      if (currentSlide === 0) {
         currentSlide = maxSlide - 1;
      } else {
         currentSlide--;
      }
      goToSlide(currentSlide);
   }

   btnRight.addEventListener('click', nextSlide);
   btnLeft.addEventListener('click', prevSlide);

   dotContainer.addEventListener('click', function (e) {
      if (e.target.classList.contains('dots__dot')){
         currentSlide = e.target.dataset.slide;
         goToSlide(currentSlide);
      }
   })

   // needs keydown function that activates when interescting the section

   testimonalSection.classList.remove('hidden');

   // assign height to slides wrapper
   slides.forEach((s, i) => {
      if (tallestElement < s.offsetHeight) tallestElement = s.offsetHeight;
   });
   slideWrapper.style.height = `${tallestElement}px`;

}

export function revealOnScroll() {
   const allSections = document.querySelectorAll('.section')
   
   const revealSection = function (entries, observer) {
      const [entry] = entries;

      if (!entry.isIntersecting) return;

      entry.target.classList.remove('section--hidden');
      observer.unobserve(entry.target);
   }

   const sectionObserver = new IntersectionObserver(revealSection, {
      root: null,
      threshold: 0.20
   })

   allSections.forEach(function (section) {
      sectionObserver.observe(section);
      section.classList.add('section--hidden');
   })
}


// Page functions



// Footer Functions
// export function footerHeight() {
//    const mainElement = document.querySelector('main');
//    const footerHeight = document.querySelector('.footer').offsetHeight;
//    mainElement.style.marginBottom = `${footerHeight}px`;
// }